<mat-form-field
  [appearance]="appearance"
  [class.clear-button-always-visible]="clearButtonAlwaysVisible"
  [class.valid]="!isInputInvalid()"
  [class.border]="hasBorder && !isInputInvalid()">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <span matPrefix class="prefix" *ngIf="prefix">{{ prefix }}</span>
  <mat-icon
    *ngIf="prefixIconName && !inputControl.value"
    matIconPrefix
    [svgIcon]="prefixIconName"
    [ngClass]="'prefix-icon'"></mat-icon>
  <div class="input-container">
    <input
      matInput
      #inputElement
      [readonly]="readonly"
      [ngClass]="{ 'center-text': isPriceField }"
      [formControl]="inputControl"
      (focus)="isNumberField ? onFocus() : null"
      (blur)="isNumberField ? onBlur($event.target.value) : null"
      [appDynamicAttributes]="inputProps"
      [mask]="mask"
      [showMaskTyped]="showMaskTyped"
      [shownMaskExpression]="shownMaskExpression"
      [name]="inputProps?.name"
      [attr.autocomplete]="inputProps?.autocomplete" />
    <span *ngIf="isPriceField" class="euro-sign">€</span>
  </div>
  <button
    type="button"
    tabindex="-1"
    matSuffix
    mat-icon-button
    class="input-button"
    *ngIf="isPasswordField"
    (click)="togglePasswordVisibility()">
    <mat-icon>
      {{ inputProps['type'] === 'password' ? 'visibility' : 'visibility_off' }}
    </mat-icon>
  </button>
  <button
    type="button"
    tabindex="-1"
    matSuffix
    mat-icon-button
    class="input-button"
    aria-label="Clear-input"
    *ngIf="clearButtonAlwaysVisible || (showCloseButton && inputControl.value)"
    (click)="clearInput()">
    <mat-icon svgIcon="close-icon"></mat-icon>
  </button>
  <mat-hint *ngIf="ibanInput && inputControl.valid && inputControl.touched">
    Gültige IBAN
  </mat-hint>
  <mat-error *ngIf="isInputInvalid()" class="error">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>
